import { Box } from '@factorialco/deprecated-design-system'
import { ItemModuleFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import Carousel from 'modules/marketplace_modules/components/Carousel'
import Contact from 'modules/marketplace_modules/components/Contact'
import StepByStepDescription from 'modules/marketplace_modules/components/StepByStepDescription'
import { useCheckModuleAcquired } from 'modules/marketplace_modules/hooks/useCheckModuleAcquired'
import { isValidIconType, isValidModule } from 'modules/marketplace_modules/lib/typesValidation'
import UpsellTrialBanner from 'modules/upsell/components/UpsellTrialBanner'

type ContentType = {
  module: ItemModuleFragment
}

export default function Content({ module }: ContentType) {
  const { company } = useCurrentSession()
  const { inFreeTrial } = company.subscription
  const isAcquired = useCheckModuleAcquired(module.chargebeeModuleName || '') ?? false

  const videoUrl = `https://www.youtube.com/embed/${
    module?.externalUrl?.split('v=')[1]?.split('&')[0]
  }`

  const images = module?.images?.map((image) => image.url)

  const carouselImages = images?.map((img) => {
    const imgObj = {
      url: img,
      alt: '',
    }
    return imgObj
  })

  const getMedia = () => {
    if (module?.externalUrl) {
      return (
        <Box
          padding="s32"
          maxWidth="widePage"
          background="grey100"
          borderRadius={{
            all: 'abs016',
          }}
          border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
          style={{ marginTop: '32px', alignSelf: 'center' }}
        >
          <iframe
            height="100%"
            width="100%"
            src={videoUrl}
            allowFullScreen
            style={{
              width: 'min(898px, 70vw)',
              aspectRatio: '16/9',
              overflow: 'hidden',
              borderRadius: '16px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
            }}
          />
        </Box>
      )
    } else if (carouselImages) {
      return <Carousel media={carouselImages} />
    }
  }

  return (
    <Box gap="s32" paddingY="s24">
      {!inFreeTrial && <UpsellTrialBanner module={module} />}
      <Contact
        data={{
          icon: isValidIconType(module.icon) ? module.icon : undefined,
          title: module.translatedName || '',
          description: module.shortDescription || '',
          chargebeeModuleId: module.chargebeeModuleId || '',
          chargebeeModuleName: isValidModule(module.chargebeeModuleName)
            ? module.chargebeeModuleName
            : undefined,
          moduleSlug: module.slug,
          billingAddonReference: module.billingAddonReference || undefined,
          crossSellingBillingAddonReference: module.crossSellingBillingAddonReference || undefined,
        }}
        moduleId={module.slug}
        isAcquired={isAcquired}
      />
      {getMedia()}
      <Box maxWidth="widePage" paddingY="s48" style={{ alignSelf: 'center' }}>
        <StepByStepDescription
          stepByStepDescription={module.description || ''}
          id={module.id || ''}
        />
      </Box>
    </Box>
  )
}
